import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { User, UserStatus } from '../../../types/user'; // (1) استيراد UserStatus enum
import Icon from '../../../components/common/Icon';
import styles from '../../../components/layout/Layout.module.css';

type OpenDeleteDialogFn = (user: User) => void;

// (2) دالة مساعدة لترجمة الحالات إلى العربية مع ألوان
const renderUserStatus = (status: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE:
      return <span style={{ color: 'green', fontWeight: 'bold' }}>نشط</span>;
    case UserStatus.PENDING_APPROVAL:
      return <span style={{ color: 'orange', fontWeight: 'bold' }}>بانتظار الموافقة</span>;
    case UserStatus.SUSPENDED:
      return <span style={{ color: 'purple', fontWeight: 'bold' }}>موقوف</span>;
    case UserStatus.INACTIVE:
      return <span style={{ color: 'red', fontWeight: 'bold' }}>غير نشط</span>;
    default:
      return <span>{status}</span>;
  }
};

export const getUserColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<User>[] => [
  {
    header: 'البريد الإلكتروني',
    accessorKey: 'email', // هذا الحقل هو المعرف الرئيسي للمستخدم الآن
  },
  {
    header: 'رقم الهاتف',
    accessorKey: 'phone', // (3) استبدال 'name' بـ 'phone'
  },
  {
    header: 'الدور',
    accessorKey: 'role',
  },
  {
    header: 'الحالة',
    accessorKey: 'status',
    // (4) استخدام الدالة المساعدة لعرض الحالة بشكل أفضل
    cell: ({ row }) => renderUserStatus(row.original.status),
  },
  {
    header: 'تاريخ الإنشاء',
    accessorFn: (row) => {
      // إضافة تحقق للتأكد من وجود التاريخ
      return row.created_at ? new Date(row.created_at).toLocaleDateString('ar-EG') : 'N/A';
    },
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const user = row.original;
      return (
        <div className={styles.actionButtons}>
          <Link to={`/admin/users/edit/${user.id}`} className={`${styles.actionButton} ${styles.edit}`} title="تعديل">
             <Icon as={FaEdit} style={styles.icon} />
          </Link>
          <button onClick={() => openDeleteDialog(user)} className={`${styles.actionButton} ${styles.delete}`} title="حذف">
            <Icon as={FaTrashAlt} style={styles.icon} />
          </button>
        </div>
      );
    },
  },
];
